import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAuth } from "auth";
import { networkTypeSelector } from "store/userSliceHelpers";
import { AppConfig } from "types/appConfig";
import { getAppConfig } from "utils/AxiosUtil";

// Server-owned constants. Keyed by network because the values are per-chain, and
// left at the client's default staleTime: Infinity - they only change on a deploy.
export function useAppConfig() {
  const { user } = useAuth();
  const networkType = useSelector(networkTypeSelector);
  return useQuery<AppConfig>({
    queryKey: ["appConfig", networkType],
    queryFn: async () => {
      const res = await getAppConfig(networkType);
      return res.data;
    },
    enabled: !!user,
  });
}

/** `undefined` until the config lands; callers must gate on `useAppConfig().isPending`. */
export function useRedeemAddress(): string | undefined {
  return useAppConfig().data?.redeemAddress;
}
